import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import moment from "moment";
import TableFilter from "components/Shared/AppTable/TableFilter";
import BaseSelect from "components/Shared/Base/BaseSelect";
import { useCustomParams } from "hooks/useCustomParams";

const DATE_RANGE_OPTIONS = [
  { label: "Last 7 Days", value: "last7days" },
  { label: "Last Month", value: "lastMonth" },
  { label: "Custom", value: "custom" },
];

const getRange = (range) => ({
  fromDate:
    range === "lastMonth"
      ? moment().subtract(1, "month").format("YYYY-MM-DD")
      : moment().subtract(6, "days").format("YYYY-MM-DD"),
  toDate: moment().format("YYYY-MM-DD"),
});

const EBillReportFilter = ({ disabled = false }) => {
  const { params, appendParams } = useCustomParams();

  useEffect(() => {
    if (!params.timeRange) {
      appendParams({ timeRange: "last7days", ...getRange("last7days") });
    }
  }, [params.timeRange, appendParams]);

  const handleRange = (value) => {
    appendParams({
      timeRange: value,
      ...(value === "custom" ? {} : getRange(value)),
    });
  };

  return (
    <TableFilter
      searchLabel="Shipment ID / Invoice No"
      disabled={disabled}
      initialFilters={3}
    >
      <BaseSelect
        fullWidth
        label="Date Range"
        value={params.timeRange || "last7days"}
        options={DATE_RANGE_OPTIONS}
        getOptionLabel={(option) => option?.label || ""}
        getOptionValue={(option) => option?.value || ""}
        onChange={(event) => handleRange(event.target.value)}
      />
      {params.timeRange === "custom" && (
        <>
          <TextField
            label="From Date"
            type="date"
            size="small"
            fullWidth
            value={params.fromDate || ""}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: params.toDate || moment().format("YYYY-MM-DD"),
            }}
            onChange={(event) => appendParams({ fromDate: event.target.value })}
          />
          <TextField
            label="To Date"
            type="date"
            size="small"
            fullWidth
            value={params.toDate || ""}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: params.fromDate || undefined,
              max: moment().format("YYYY-MM-DD"),
            }}
            onChange={(event) => appendParams({ toDate: event.target.value })}
          />
        </>
      )}
    </TableFilter>
  );
};

export default EBillReportFilter;
